export default __webpack_public_path__ + "something_went_wrong.png";